export default [
	{
		imageClass: "anna_f1",
		title: "ANNA F1",
	},
	{
		imageClass: "jambar_f1",
		title: "JAMBAR F1",
	},
	{
		imageClass: "victoria_f1",
		title: "VICTORIA F1",
	},
	{
		imageClass: "eden_f1",
		title: "EDEN F1",
	},
];
